module.exports = __webpack_public_path__ + "static/media/memoir-ss.cf846be6.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/Portfolio/images/memoir-ss.png
 ** module id = 205
 ** module chunks = 0
 **/